export enum OrgDashboardModes {
  APPOINTMENT_SCHEDULE = 'appointmentSchedule',
  PATIENT_LIST = 'patientList',
}
